import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
  onClick?: () => void;
  showIcon?: boolean;
}
export function CTAButton({
  text,
  href = 'https://pagos.avanzalab.online/cart/53119797002554:1',
  className = '',
  onClick,
  showIcon = true
}: CTAButtonProps) {
  const baseClasses = 'group relative inline-flex items-center justify-center px-8 py-5 text-lg md:text-xl font-black text-white uppercase tracking-wide overflow-hidden rounded-lg shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-all duration-300 transform hover:scale-105 active:scale-95 w-full md:w-auto';
  const content = <>
      <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-[#D4AF37] via-[#B8860B] to-[#996515]" data-id="element-95"></span>
      <span className="absolute bottom-0 right-0 block w-64 h-64 mb-32 mr-4 transition duration-500 origin-bottom-left transform rotate-45 translate-x-24 bg-[#F3E5AB] opacity-10 group-hover:rotate-90 ease" data-id="element-96"></span>
      <span className="relative flex items-center gap-2 text-center" data-id="element-97">
        {text}
        {showIcon && <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-98" />}
      </span>
    </>;
  if (onClick) {
    return <button onClick={onClick} className={`${baseClasses} ${className}`} data-id="element-99">
        {content}
      </button>;
  }
  return <a href={href} className={`${baseClasses} ${className}`} data-id="element-100">
      {content}
    </a>;
}